import { Box, Stack, Typography } from "@mui/material";
import { CustomAvatar } from "../../../components";

function MessageCard() {
  return (
    <Stack
      direction="row"
      alignItems={"center"}
      justifyContent={"space-between"}
      mb={2}
    >
      <Stack direction="row" alignItems={"center"}>
        <CustomAvatar
          rootStyle={{
            border: "none",
            marginTop: 0,
            marginLeft: 0,
            marginRight: 1.5,
          }}
          avatarStyle={{ borderRadius: 100, height: 48, width: 48 }}
        />
        <Box>
          <Typography>Bounougou André</Typography>
          <Typography fontSize={13}>Vous voulez faire une offre de placement p...</Typography>
        </Box>
      </Stack>
      <Box>
        <Typography fontSize={13}>19:14</Typography>
        <Typography></Typography>
      </Box>
    </Stack>
  );
}

export default MessageCard;
